module.exports = __webpack_public_path__ + "assets/briefcase.966bbc4c.svg";